import type { ZFilterGroup } from "src/business/queryBuilder";
import { zSecSpecRow } from "src/business/specification/ZSecSpecRow";
import { zSidLabel } from "src/types/ZSidLabel";
import z from "zod";

import { zObjectPermissions } from "../access/ZObjectAccess";
import {
  zSafeDataMap,
  ZSafeValues,
  zUnsafeDataMap,
} from "../attribute/ZAttrValue";
import { zEntityError } from "../error/ZEntityError";
import { zSpecification } from "../specification";
import { zSysDataHistory } from "../sysData/ZSysData";

export type ClassesFilter = {
  parentId?: string;
  query?: string;
  queryBuilderFilter?: ZFilterGroup;
};

export type ClassParentsFilter = { text?: string };

// Это пришлось сделать потому что в ответе системые данные приходят в неправильном формате
const zSpecPartial = zSpecification.omit({
  updatedAt: true,
  updatedBy: true,
  createdAt: true,
  createdBy: true,
});

export const zClassCommon = z.object({
  id: z.string(),
  displayId: z.number(),
  name: z.string(),
  classifier: zSidLabel.nullish(),
  parents: zSidLabel.array().array().nullish(),
  primarySchema: zSpecPartial.optional(),
  secondarySchemas: zSecSpecRow.array().optional(),
  readonlyAttributes: z
    .string()
    .array()
    .optional()
    .describe("список id атрибутов, запрещённых для редактирования"),
  ...zSysDataHistory.shape,
});
export type ZClassCommon = z.infer<typeof zClassCommon>;

export type ClassValues = Record<string, ZSafeValues>;

export const zClassRow = z.object({
  ...zClassCommon.shape,
  data: zSafeDataMap,
});
export type ZClassRow = z.infer<typeof zClassRow>;

export const zClassUnsafe = z.object({
  ...zClassCommon.shape,
  data: zUnsafeDataMap.describe("Имя схемы => {имя атрибута => значение}"),
  permissions: zObjectPermissions.optional(),
  errors: zEntityError.array().nullish(),
});

export type ZClassUnsafe = z.infer<typeof zClassUnsafe>;
